import { AHText, AHTextFonts } from "arkh";
import { FormattedMessage } from "react-intl";
import React from "react";

import { graphql, useFragment } from "react-relay";
import { IntegrationAdminListItem } from "./components/IntegrationAdminListItem";

import { IntegrationAdminWebFetcherListItem_IntegrationWebFetcher$key } from "./__generated__/IntegrationAdminWebFetcherListItem_IntegrationWebFetcher.graphql";

export function IntegrationAdminWebFetcherListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  integration: IntegrationAdminWebFetcherListItem_IntegrationWebFetcher$key;
}) {
  const integration = useFragment(
    graphql`
      fragment IntegrationAdminWebFetcherListItem_IntegrationWebFetcher on IntegrationWebFetch {
        __typename
        id
        url

        lastError
      }
    `,
    props.integration
  );
  return (
    <IntegrationAdminListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={() => {}}
      active
    >
      <AHText type="title-small" font={AHTextFonts.REGULAR} numberOfLines={1}>
        <FormattedMessage
          description="IntegrationsAdminWebFetcherListItem title"
          defaultMessage="Web Fetcher"
        />
      </AHText>
      {integration.lastError ? (
        <AHText>
          <FormattedMessage
            defaultMessage="Failing"
            description="StoreAdminActiveIntegrations failing"
          />
          : {integration.lastError}
        </AHText>
      ) : (
        <AHText>{integration.url}</AHText>
      )}
    </IntegrationAdminListItem>
  );
}
